jQuery( document ).ready(function( $ ) {

    // Set href link to void to prevent page reload
    $( '.ads-landing__start a, .elementor-tab-title a' ).attr( 'href', 'javascript:void(0);' );

    $( '.ads-landing__start' ).click(function() {
        $( '.ads-landing' ).hide();
        $( '.ads-steps' ).show();
    });

    // Prevent elementor tab default action
    $( '.elementor-tab-title' ).click(function( e ) {
        e.stopImmediatePropagation();
    });

    // Generate tab navigation
    let nav_buttons = '<div class="form__group">'
                    + '    <button class="form__back alignleft">Back</button>'
                    + '    <button class="form__next alignright">Next</button>'
                    + '</div>';
    $( '.ads-steps form' ).append( nav_buttons );

    $( '.form__next, .form__back' ).click(function( e ) {
        e.preventDefault();

        let tab_id = $( this ).parents( '.elementor-tab-content' ).data( 'tab' );
        let next_id = tab_id + ($( this ).hasClass( 'form__next' ) ? 1 : -1);

        // Show ads landing section if first back button is clicked
        if (next_id <= 0) {
            $( '.ads-steps' ).hide();
            $( '.ads-landing' ).show();
            
            return false;
        }

        /** 
         * Hide steps section if next tab doesn't exist
         * and show confirmation section
         */
        if ( !$( '.elementor-tab-title[data-tab=' + next_id + ']' ).length ) {
            $( '.ads-steps' ).hide();
            $( '.ads-confirmation' ).show();

            return false;
        }

        // Remove current active tab
        if ($( this ).hasClass( 'form__back' )) {
            $( '.elementor-tab-title[data-tab=' + tab_id + ']' ).removeClass( 'elementor-active' );
        }
        $( '.elementor-tab-content[data-tab=' + tab_id + ']' ).removeClass( 'elementor-active' ).hide();

        // Add new active tab
        $( '.elementor-tab-title[data-tab=' + next_id + ']' ).addClass( 'elementor-active' );
        $( '.elementor-tab-content[data-tab=' + next_id + ']' ).addClass( 'elementor-active' ).show();
    });
});
